import React, { useEffect, useRef, useState } from "react";
import ChatNavbar from "./ChatNavbar";
import InputMessage from "./InputMessage";
import * as signalR from "@microsoft/signalr";
import { getActiveConverstionList } from "../../../Services/getActiveConverstionList";
import bellSound from "../../../../../assets/audio/notification_tone.mp3";
import downloadIcon from "../../../../../assets/icons/downloadicon.png";
import pdfIcon from "../../../../../assets/icons/pdficon.png";
import noMsg from "../../../../../assets/icons/NoMessageIcon.png";
import { API_BASE_URL } from "../../../../../config";
import { getMarkHomeUserMsg } from "../../../Services/getMarkHomeUserMsg";
import StartConversation from '../../../../../images/home-landing-page/start-conversation.png';
import EmptyProfileImage from '../../../../../images/navbar/empty-profile-image.png'
import { getMarkBusinessUserMsg } from "../../../../HomeMessage/Services/getMarkBusinessUserMsg";
import { jwtDecode } from "jwt-decode";
import { getJobDetails } from "../../../Services/getJobDetails";
import Avatar2 from "../../../../Avatar/Avatar2";
import { formatMessageTime, formatDateSeparator, isDifferentDay } from '../../../../../utils/chatFormatters';
import api from '../../../../../api/api.js';
import { useNavigate } from 'react-router-dom'; 
import { MapPin, Phone, Search, User, X, ChevronDown, ChevronUp, ChevronRight, Lock } from "lucide-react";


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 

function Index({
    activeConversation,
    setConversationSearchId,
    ChatSearching,
    setUnreadMessages,
    setNotification,
    notification,
    homeData,
    onBack
})
{
  const navigate = useNavigate();

    const [messages, setMessages] = useState([]);
    const [connection, setConnection] = useState(null);
    const [messageText, setMessageText] = useState("");
    const [username, setUsername] = useState(""); // Set your username here or from props
    const [recipient, setRecipient] = useState("Ali"); // Set the recipient here or from props
    const [filePreview, setFilePreview] = useState(null); // For previewing the image
    const [attachementUrl, setAttachmentUrl] = useState(null);
    const [textNoMsg, setTextNoMsg] = useState(false);
    const [reconnect, setReconnect] = useState(false);
    const [userLoggedInImage, setUserLoggedInImage] = useState(null);
    const [jobCardDetails, setJobCardDetails] = useState(null);
    const [currentUserId, setCurrentUserId] = useState(null);

    const messagesEndRef = useRef(null);
    const prevMessagesRef = useRef([]);
    // Create a ref map to store references for each message
    const messageRefs = useRef({});
    const chatContainerRef = useRef(null);

    // 2. ADD STATE FOR PAGINATION
    const [page, setPage] = useState(1);
    const [hasMoreMessages, setHasMoreMessages] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

      // --- NEW STATE ---
    const [isVerified, setIsVerified] = useState(true); // Default true to prevent flash, check immediately
    const [checkingAuth, setCheckingAuth] = useState(true);


    
    const scrollToBottom = (behavior = "smooth") => {
        const c = chatContainerRef.current;
        if (c) {
            c.scrollTo({ top: c.scrollHeight, behavior: behavior });
        }
    };



    useEffect(() => {
        const checkSubscription = async () => {
            const token = localStorage.getItem('token');
            if (!token) return;
            
            const decoded = jwtDecode(token);
            // Default to 'Business' if not present, as this component is for businesses
            const userType = decoded.UserType || localStorage.getItem('userType');

            // 1. If Home User, always allowed (Visible)
            if (userType === 'Home') {
                setIsVerified(true);
                setCheckingAuth(false);
                return;
            }

            // 2. If Business User, hit the endpoint with the ID
            if (userType === 'Business') {
                try {
                    // Extract the ID per your logic (nameid is the businessId)
                    const bizIdToCheck = parseInt(decoded.nameid, 10);
                    
                    // Pass the ID in the query string
                    const { data } = await api.get(`/api/Subscription/hasValidSubscription?bizid=${bizIdToCheck}`);
                    
                    console.log("Subscription Check Result:", data);
                    setIsVerified(data.isVerified); 
                } catch (error) {
                    console.error("Subscription check failed", error);
                    setIsVerified(false); // Lock safely on error
                } finally {
                    setCheckingAuth(false);
                }
            }
        };

        checkSubscription();
    }, [activeConversation]); 




    // Scroll to specific message when ChatSearching is active
    useEffect(() =>
    {
        if (ChatSearching && ChatSearching.messageId)
        {
            const messageRef = messageRefs.current[ChatSearching.messageId];
            if (messageRef)
            {
                messageRef.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }, [ChatSearching]);


    //useEffect(scrollToBottom, [messages]);

    // 3. REWRITE THE MAIN useEffect TO HANDLE PAGINATION AND INITIAL SCROLL
    useEffect(() => {
        if (activeConversation && currentUserId) {
            setConversationSearchId(activeConversation?.conversationId);
            if (sessionStorage.getItem('userImage') !== "null")
                setUserLoggedInImage(sessionStorage.getItem('userImage'));
            
            // Reset state for the new conversation
            setMessages([]);
            setPage(1);
            setHasMoreMessages(true);
            setTextNoMsg(false);
            
            // Fetch first page of messages
            fetchMessages(activeConversation.conversationId, 1);
            
            // Wait for render, then scroll to bottom
            setTimeout(scrollToBottom, 0); 
        }
    }, [activeConversation, currentUserId]);




    const fetchMessages = async (convId, pageNum) => {
        if (isLoading || !hasMoreMessages) return;

        setIsLoading(true);
        try {
            const response = await getActiveConverstionList(convId, pageNum);

            if (!Array.isArray(response)) {
                console.error("API Error: The response was not an array.", response);
                setHasMoreMessages(false);
                if (pageNum === 1) setTextNoMsg(true);
                return;
            }

            if (response.length === 0) {
                setHasMoreMessages(false);
                if (pageNum === 1) setTextNoMsg(true);
                return;
            }

            setTextNoMsg(false);
            
            const formatMessages = response.map((msg) => ({
                id: msg.messageId, // Use unique ID for the key
                // Correctly determine "sent" (user) vs "received" (receiver)
                type: msg.businessUserId === currentUserId ? 'user' : 'receiver',
                message: msg.message,
                rawDate: msg.dated,
                messageTime: formatMessageTime(msg.dated),
                attachmentUrl: msg.attachmentUrl,
                attachmentExtension: msg.attachmentExtension,
                messageId: msg.messageId,
                quoteId: msg.quoteId || homeData?.quoteId,
                conversationId: msg.conversationId || convId,
            }));

            const chatContainer = chatContainerRef.current;
            const previousScrollHeight = chatContainer?.scrollHeight || 0;

            setMessages((prevMessages) => {
                const newUniqueMessages = formatMessages.filter(
                    (newMsg) => !prevMessages.some((prevMsg) => prevMsg.messageId === newMsg.messageId)
                );
                return [...newUniqueMessages, ...prevMessages];
            });

            // Restore scroll position after prepending messages
            if (chatContainer && pageNum > 1) {
                chatContainer.scrollTop = chatContainer.scrollHeight - previousScrollHeight;
            }

            setPage((prevPage) => prevPage + 1);

            if (pageNum === 1) {

                setTimeout(() => scrollToBottom("auto"), 0); 

                if (homeData?.userType === "Business") {
                    BusinessUserMessageRead(convId, currentUserId);
                } else {
                    HomeUserMessageRead(convId);
                }
            }
        } catch (error) {
            console.error("Failed to fetch messages:", error);
            setHasMoreMessages(false);
        } finally {
            setIsLoading(false);
        }
    };
    
    // 6. INFINITE SCROLL HANDLER
    const handleScroll = () => {
        if (chatContainerRef.current?.scrollTop === 0 && !isLoading && hasMoreMessages) {
            fetchMessages(activeConversation?.conversationId, page);
        }
    };




    const HomeUserMessageRead = async (conversationId) =>
    {
        try
        {
            const response = await getMarkHomeUserMsg(conversationId);
            console.log("response", response)

        } catch (error)
        {
            console.error(error);
        }
    }
    const BusinessUserMessageRead = async (conversationId, businessUserId) =>
    {
        try
        {
            const response = await getMarkBusinessUserMsg(conversationId, businessUserId);
            console.log("response", response)

        } catch (error)
        {
            console.error(error);
        }
    }

    useEffect(() =>
    {

        // Define userType and userId dynamically if needed
        const userType = "businessUser"; // Replace with dynamic value if necessary
        const token = localStorage.getItem('token');
        if (token !== null)
        {
            const decodeToken = jwtDecode(token);
            const userId = parseInt(decodeToken.nameid, 10);
            setCurrentUserId(userId);
            //const userId = "60";
            setUsername(decodeToken.UserName);
            // Set up the SignalR connection
            //  const connect = new signalR.HubConnectionBuilder()
            //    .withUrl(`http://192.168.18.149:5280/chatHub?userType=${userType}&userId=${userId}`)
            //    .withAutomaticReconnect()
            //    .build();
            const connect = new signalR.HubConnectionBuilder()
                .withUrl(`${API_BASE_URL}/chatHub?userType=${userType}&userId=${userId}&quoteId=${homeData?.quoteId}`, {
                    withCredentials: true,
                })
                .withAutomaticReconnect()
                .build();
            setConnection(connect);

            // Start the connection
            connect
                .start()
                .then(() => console.log("Connected to chat hub"))
                .catch((err) => console.error("Connection failed: ", err));
            setReconnect(false);
            return () =>
            {
                if (connect)
                {
                    connect.stop();
                }
            };
        };


    }, [homeData]);



useEffect(() => {
        if (connection) {
            const audio = new Audio(bellSound);
            const myUserType = "businessUser";

            const handleReceiveMessage = (response) => {
                // FIX #1: Ignore the "echo" of a message sent by the current user.
                // This prevents self-duplication.
                if (response.senderUserId === currentUserId && response.senderUserType === myUserType) {
                    return; 
                }

                // --- Main Logic for Handling Incoming Messages ---

                // A) Is this message for the conversation we currently have open?
                if (response.conversationId == activeConversation?.conversationId) {
                    
                    // YOUR LOGIC: Correctly integrated to construct the full attachment URL.
                    let finalAttachmentUrl = response?.attachmentUrl;
                    if (finalAttachmentUrl && !finalAttachmentUrl.startsWith('http') && !finalAttachmentUrl.startsWith('data:')) {
                        finalAttachmentUrl = `${API_BASE_URL}${finalAttachmentUrl.startsWith('/') ? '' : '/'}${finalAttachmentUrl}`;
                        console.log("Constructed SignalR Attachment URL:", finalAttachmentUrl);
                    }

                    // Use the functional update form to ensure we have the latest state
                    setMessages((prevMessages) => {
                        // Check if we've somehow already processed this message
                        const messageExists = prevMessages.some(msg => msg.messageId === response.messageId);

                        if (messageExists) {
                            return prevMessages; // If it exists, don't change the state
                        }

                        // If it's a new message, add it to the state array
                        return [
                            ...prevMessages,
                            {
                                id: response.messageId,
                                type: "receiver",
                                message: response?.message,
                                rawDate: response?.messageTime,
                                messageTime: formatMessageTime(response?.messageTime),
                                attachmentUrl: finalAttachmentUrl, // Using your constructed URL
                                attachmentExtension: response?.attachmentExtension,
                                messageId: response.messageId, // Important for the 'messageExists' check
                                quoteId: response?.quoteId || homeData?.quoteId,
                                conversationId: response?.conversationId || homeData?.conversationId
                            },
                        ];
                    });

                    scrollToBottom();


                } 
                // B) If it's for a different conversation, show a notification.
                else {
                    if (!activeConversation || response.conversationId !== activeConversation.conversationId) {
                        setUnreadMessages({ num: 1, conversationId: response.conversationId });
                        audio.play().catch((error) => console.error("Error playing sound:", error));
                    }
                }
            };

            connection.on("ReceiveMessage", handleReceiveMessage);

            // Cleanup function to remove the listener when the component unmounts
            return () => {
                connection.off("ReceiveMessage", handleReceiveMessage);
            };
        }
    // Stable dependency array. This hook will now only re-run if one of
    // these core props/states changes, NOT every time a new message arrives.
    }, [connection, activeConversation, homeData, currentUserId, setUnreadMessages]);


    const handleSendMessage = async (
        messageText,
        base64File = null,
        fileName = null
    ) =>
    {
        if (!connection || connection.state !== signalR.HubConnectionState.Connected)
        {
            //alert("Connection is not !active. Reconnecting...");
            //setReconnect(true);
            toast.error("Not connected. Message will be sent once connection is restored.");
            return;
        }

        try
        {
            await connection.invoke(
                "SendPrivateMessage",
                homeData?.userId,  // Sender's ID
                messageText,
                base64File,
                fileName,
                homeData?.userType,
                homeData?.quoteId,
                homeData?.conversationId
            );

            const newMessage = {
                id: Date.now(),
                senderUserId: homeData?.userId,
                Username: username,
                type: homeData?.userType === "businessUser" ? "business" : "user",
                message: messageText,
                fileName: fileName,
                fileUrl: base64File,
                ProfilePictureUrl: "https://google.com", // Replace with actual user profile pic
                rawDate: new Date().toISOString(),
                messageTime: formatMessageTime(new Date().toISOString()),
                attachmentUrl: base64File ? attachementUrl : null,
            };

            setMessages((prevMessages) => [...prevMessages, newMessage]);

            setMessageText("");
            setAttachmentUrl(null);
            
            scrollToBottom();

        } catch (error)
        {
            console.error("Message send failed: ", error);
            toast.error("Failed to send message. Attempting to reconnect...");
        }
    };

    return (

        <>
            {activeConversation ? (
                <>
                    <ChatNavbar activeConversation={activeConversation} notification={notification} setNotification={setNotification} onBack={onBack} />
                    
                    <div className="chatbox-content" style={{ position: 'relative' }}> 

                        {/* --- THE LOCK OVERLAY --- */}
                        {(!checkingAuth && !isVerified) && (
                            <div className="subscription-lock-overlay">
                                <div className="lock-message">
                                    <div style={{display:'flex', justifyContent:'center', marginBottom:'15px'}}>
                                        <div style={{background:'#f3f4f6', padding:'15px', borderRadius:'50%'}}>
                                            <Lock size={32} color="#64748b" />
                                        </div>
                                    </div>
                                    <h3>Unlock Your Messages</h3>
                                    <p style={{color:'#666', margin:'10px 0'}}>
                                        You have a new lead! Subscribe to a plan to view client messages and reply.
                                    </p>
                                    <button 
                                        className="btn-subscribe" 
                                        onClick={() => navigate('/subscription/subscribenew')}
                                    >
                                        View Plans
                                    </button>
                                </div>
                            </div>
                        )}


                        <div 
                            className={`chatting-wrapper ${(!checkingAuth && !isVerified) ? 'blur-container' : ''}`} 
                            ref={chatContainerRef} 
                            onScroll={handleScroll}
                        >
                        
                            {isLoading && <div style={{textAlign: 'center', padding: '10px'}}>Loading older messages...</div>}


                            {jobCardDetails && (
                                <div className="job-card">
                                    <h3 className="job-title">{jobCardDetails?.jobTitle}</h3>
                                    <div className="job-details">
                                        <div className="job-quote">
                                            <strong>Quote Amount:</strong> ${jobCardDetails?.quoteAmount}
                                        </div>
                                        <div className="job-description">
                                            <strong>Description:</strong> {jobCardDetails?.jobDescription}
                                        </div>
                                    </div>
                                    {/* <button onClick={hireForJob} className="hire-button">Hire for Job</button> */}
                                </div>
                            )}



{messages.length > 0 ? (
  messages.map((message, index) => {
    const emojiOnlyRegex =
      /^(?:\p{Emoji_Presentation}|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Component}|\u200d)+$/u;
    const isEmojiOnly =
      message.message && emojiOnlyRegex.test(message.message.trim());

    // Show date separator when this message is on a different day than the previous one
    const prevMessage = index > 0 ? messages[index - 1] : null;
    const showDateSeparator = !prevMessage || isDifferentDay(prevMessage?.rawDate, message?.rawDate);

    return (
      <div
        key={message.id}
        ref={(el) => (messageRefs.current[message.messageId] = el)}
      >
        {showDateSeparator && message?.rawDate && (
          <div className="chat-date-separator">
            <span>{formatDateSeparator(message.rawDate)}</span>
          </div>
        )}
        {message.type === "receiver" ? (
          <>
            {!message?.attachmentUrl && (
              <div className="chat-msg">

                    <figure className="chat-person">
                        {/* 10. CONDITIONAL AVATAR FOR RECEIVER */}
                        {activeConversation?.userProfileUrl ? (
                            <img src={activeConversation.userProfileUrl} alt="User"/>
                        ) : (
                            <Avatar2 name={activeConversation?.userName} />
                        )}
                    </figure>


                {!message?.attachmentUrl && (
                  <div class="chat-msg-time">
                    <div className={`chat-msg-box ${isEmojiOnly ? "emoji-only" : ""}`}>
                      {message.message}
                    </div>
                    <span class="chat-time">{message.messageTime}</span>
                  </div>
                )}
              </div>
            )}

            {message?.attachmentUrl && (
              <div>
                <div className="chat-msg">
                                                    <figure className="chat-person">
                                                        {/* 11. CONDITIONAL AVATAR FOR SENDER (YOU) */}
                                                        {userLoggedInImage ? (
                                                            <img src={userLoggedInImage} alt="User" />
                                                        ) : (
                                                            <Avatar2 name={username} />
                                                        )}
                                                    </figure>
                                                   

                  <div className="chat-msg-time">
                    <div className="chat-msg-box">
                      {/* Image with Default Blur and Download Icon */}
                      <div className="chat-attachment">
                        {/* Image with Download Icon */}
                        <div className="attachment-download">
                          <img
                            src={
                              message?.attachmentExtension === ".pdf"
                                ? pdfIcon
                                : message.attachmentUrl
                            }
                            alt="Upload Image"
                          />
                          <button
                            onClick={async () => {
                              try {
                                // Fetch the file from the URL
                                const response = await fetch(message.attachmentUrl);

                                if (!response.ok) {
                                  throw new Error("Network response was not ok");
                                }

                                const blob = await response.blob();
                                const url = new URL(message.attachmentUrl);
                                const fileName = url.pathname.split("/").pop();
                                const link = document.createElement("a");

                                link.href = URL.createObjectURL(blob);
                                link.download = fileName;

                                document.body.appendChild(link);
                                link.click();

                                URL.revokeObjectURL(link.href);
                                document.body.removeChild(link);
                              } catch (error) {
                                console.error("Download failed:", error);
                              }
                            }}
                            title="Download Attachment"
                            className="flex items-center justify-center"
                          >
                            <img src={downloadIcon} alt="Download Icon" />
                          </button>
                        </div>

                        {/* This safely renders the message text below the image/attachment */}
                        {message.message && (
                          <div className="attachment-message-text">
                            {message.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <span class="chat-time">{message.messageTime}</span>
                    <div></div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {!message?.attachmentUrl && (
              <div className="chat-msg chat-sent">
                <figure class="chat-person">
                  <img
                    src={userLoggedInImage || EmptyProfileImage}
                    alt="User Image"
                  />
                </figure>
                <div class="chat-msg-time">
                  <div className={`chat-msg-box ${isEmojiOnly ? "emoji-only" : ""}`}>
                    {message.message}
                  </div>
                  <span class="chat-time"> {message.messageTime}</span>
                </div>
              </div>
            )}
            {message?.attachmentUrl && (
              <div className="chat-msg chat-sent">
                <figure className="chat-person">
                  <img
                    src={userLoggedInImage || EmptyProfileImage}
                    alt="User Image"
                  />
                </figure>
                <div class="chat-msg-time">
                  <div class="chat-msg-box">
                    <div class="chat-attachment">
                      <img
                        src={
                          message?.attachmentExtension === ".pdf"
                            ? pdfIcon
                            : message.attachmentUrl
                        }
                        alt="Upload Image"
                      />
                    </div>
                    {message.message}
                  </div>
                  <span class="chat-time">{message.messageTime}</span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
  })
) : (
  <div>
    {textNoMsg ? (
      <div className="messaging-center start-msg">
        <img src={noMsg} alt="No Messages" />
        <h6>Select a Contact to Start a Conversation</h6>
        <p>
          Choose a contact from your list to begin chatting and stay connected.
        </p>
      </div>
    ) : (
      "loading..."
    )}{" "}
  </div>
)}



                            {/* This div ensures we always scroll to the bottom */}
                            <div ></div>
                        </div>


                        <div className="send-chat-actions" style={!isVerified ? { display: 'none' } : {}}>
                            <InputMessage
                                filePreview={filePreview}
                                setFilePreview={setFilePreview}
                                onSendMessage={handleSendMessage}
                                setAttachmentUrl={setAttachmentUrl}
                            />
                        </div>

                    </div>



                </>
            ) : (
                <div class="messaging-center start-msg">
                    <img src={StartConversation} />
                    <h6>
                        Select a Contact to Start a Conversation
                    </h6>
                    <p>Choose a contact from your list to begin chatting and stay connected.</p>
                </div>
            )}

        </>
    );
}

export default Index;
